.modal {
  max-width: 954px;
  /* width: 100%; */
}

.title {
  font-size: var(--fs-medium-heading);
  font-weight: 500;
  margin: 0;
  color: var(--static-text-strong);
}

.modalBody {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.row {
  display: flex;
  gap: 1rem;
  width: 100%;
}

.formGroup {
  /* display: grid;
  grid-template-columns: 50% 50%; */
  display: flex;
  gap: 2rem;
}

.formGroup label {
  justify-self: start;
  font-size: var(--fs-small);
  font-weight: 500;
  color: var(--static-text-standard);
  white-space: nowrap;
}

.formGroup input,
.formGroup select {
  padding: 4px 12px;
  border-radius: 8px;
  border: 1px solid var(--static-divider-standard);
  background-color: var(--static-background-strong);
  color: var(--static-text-strong);
  font-size: var(--fs-standard);
  width: 100%;
}

.formGroup input:focus,
.formGroup select:focus {
  outline: none;
  border-color: var(--static-accent-standard);
}

.required {
  color: var(--sentiment-text-negative);
}

.error {
  color: var(--sentiment-text-negative);
  font-size: var(--fs-small);
  margin-top: 0.5rem;
}

/* Responsive design */
@media (max-width: 768px) {
  .row {
    flex-direction: column;
    gap: 0;
  }
  
  .formGroup {
    grid-template-columns: 1fr;
    gap: 0.25rem;
  }
  
  .formGroup label {
    justify-self: start;
  }
}


.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.inputRow {
  display: grid;
  grid-template-columns: 50% 50%;
}

.inputRowFull {
  display: grid;
  grid-template-columns: 14.4% auto;
  grid-column: span 2
}

.input1 {
  /* width: 270px; */
  margin-left: auto;
  flex: 0 0 270px;
}

.cardElement {
  background-color: var(--static-background-strong) !important;
  border-radius: 8px !important;
}

/* Override Recurly element styles within cardElement */
.cardElement :global(.recurly-element) {
  background-color: var(--static-background-strong) !important;
}

